import { useState, useEffect } from "react";
import { getTeams } from "../services/team.service";

export const useTeams = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [teams, setTeams] =
    useState<Awaited<ReturnType<typeof getTeams>>["data"]>();

  useEffect(() => {
    getTeams()
      .then(({ data }) => {
        setTeams(data);
        setIsLoaded(true);
      })
      .catch(console.error);
  }, []);

  return { isLoaded, teams };
};
